import { useBookingStore } from "@/stores/apps/booking";
import { useBudgetStore } from "@/stores/apps/budget";
import { useContentStore } from "@/stores/apps/content";
import { useEventsStore } from "@/stores/apps/events";
import { useIpadHuntStore } from "@/stores/apps/ipad_hunt";
import { useLocalesStore } from "@/stores/i18n"

function formatThousands(value) {
    // Convert a number (e.g., 1000) to a string with dot as thousands separator (e.g., '1.000')
    if (value === null || value === undefined) return '';
    const number = Number(
        String(value).replace(/\./g, '').replace(',', '.')
    );
    if (isNaN(number)) return value;
    // Force the use of period for thousands, no decimals
    return number.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }


const money_calculation = (countQuiz, countCorrects, maxMoney) =>
{
    console.log(countQuiz);
    console.log(countCorrects);
    console.log(maxMoney);
    
    const percentageSuccesses = countCorrects / countQuiz    
    return Math.round(percentageSuccesses * maxMoney)
}

const cleanStore = async () => {
    const contentStore = useContentStore()
    contentStore.setDefault()
    const bookingStore = useBookingStore()
    bookingStore.setDefault()
    const budgetStore = useBudgetStore()
    budgetStore.setDefault()
    const eventStore = useEventsStore()
    eventStore.setDefault()
    const ipadStore = useIpadHuntStore()
    ipadStore.setDefault()
}

const isValidUrl = (url: string): boolean => {
    try {
        new URL(url);
        return true;
    } catch (error) {
        return false;
    }
};

const getHueRotate = (hex: string) => {
    // Convert hex to RGB
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;
    
    // Calculate hue
    let h;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    
    if (max === min) {
      h = 0;
    } else {
      const d = max - min;
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
        default: h = 0;
      }
      h *= 60;
    }
    
    return h;
  };

export { money_calculation, cleanStore, isValidUrl, getHueRotate, formatThousands }